import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  RemoteControlAdminService,
  PosTablet,
  RemoteControlSession,
  PosAgent,
  DesktopSession,
} from '../../../services/remote-control-admin.service';
import { PosAgentAdminService } from '../../../services/pos-agent-admin.service';

@Component({
  selector: 'app-pos-monitoring',
  templateUrl: './pos-monitoring.component.html',
  styleUrls: ['./pos-monitoring.component.scss'],
})
export class PosMonitoringComponent implements OnInit, OnDestroy {
  role = localStorage.getItem('role');
  tablets: PosTablet[] = [];
  activeSession: RemoteControlSession | null = null;
  isConnecting = false;

  agents: PosAgent[] = [];
  activeDesktopSession: DesktopSession | null = null;
  isDesktopConnecting = false;

  // Desktop Overlay (new standalone overlay via PosAgentAdminService)
  desktopOverlayVisible = false;
  desktopControlTerminalId: string | null = null;

  private subscriptions: Subscription[] = [];

  constructor(
    public remoteControlService: RemoteControlAdminService,
    public posAgentAdminService: PosAgentAdminService,
  ) {}

  ngOnInit(): void {
    const adminId = localStorage.getItem('managerId') || '';
    this.remoteControlService.connect(adminId, this.role || '');
    this.remoteControlService.loadOnlineTablets();
    this.remoteControlService.loadOnlineAgents();

    this.subscriptions.push(
      this.remoteControlService.onlineTablets$.subscribe(tablets => {
        this.tablets = tablets;
      }),
      this.remoteControlService.activeSession$.subscribe(session => {
        this.activeSession = session;
        if (session !== null) {
          this.isConnecting = false;
        }
      }),
      this.remoteControlService.onlineAgents$.subscribe(agents => {
        this.agents = agents;
      }),
      this.remoteControlService.activeDesktopSession$.subscribe(session => {
        this.activeDesktopSession = session;
        if (session !== null) {
          this.isDesktopConnecting = false;
        }
      }),
    );
  }

  takeControl(posSocketId: string): void {
    this.isConnecting = true;
    this.remoteControlService.requestControl(posSocketId);
  }

  endSession(): void {
    this.remoteControlService.endSession();
    this.isConnecting = false;
  }

  getAgentForTablet(terminalId: string): PosAgent | undefined {
    return this.agents.find(a => a.terminalId === terminalId);
  }

  takeDesktopControl(terminalId: string): void {
    const agent = this.getAgentForTablet(terminalId);
    if (!agent) return;
    this.isDesktopConnecting = true;
    this.remoteControlService.requestDesktopControl(terminalId, agent);
  }

  endDesktopSession(): void {
    this.remoteControlService.endDesktopSession();
    this.isDesktopConnecting = false;
  }

  startDesktopView(terminalId: string): void {
    this.desktopControlTerminalId = terminalId;
    this.desktopOverlayVisible = true;
  }

  onDesktopOverlayClosed(): void {
    this.desktopOverlayVisible = false;
    this.desktopControlTerminalId = null;
  }

  formatTime(dateStr: string): string {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
